import { createReducer } from "@reduxjs/toolkit";
import { deleteCookie } from "../../utils/utils";
import { LANGUAGE } from "../../locales/languages";
import { USERPOSITIONS } from "../../constants/userPositions";
import {
  authAC,
  logoutAC,
  languageAC,
  authErrorAC,
  authLoaderAC,
  dashboardLoaderAC,
  addNotificationAC,
  setCurrentUserInfoAC,
  deleteNotificationAC,
} from "./systemActionCreators";

export type typeNotificationItem = {
  id: string;
  message: string;
};

export type typeCurrentUser = {
  position: USERPOSITIONS | null;
  authorizedUser: {
    token: string;
    userId: string;
    roles: string[];
    username: string;
    serviceUser: boolean;
    primaryTenant: string;
    originalPrimaryTenant: string;
    allowedTenants: string[] | null;
    forcedPrimaryTenant: string | null;
  };
};

export type ISystemState = {
  auth: boolean;
  language: LANGUAGE;
  authError: boolean;
  authLoader: boolean;
  dashboardLoader: boolean;
  login: string | undefined;
  userInfo: typeCurrentUser | null;
  notificationList: typeNotificationItem[];
};

export const initialState: ISystemState = {
  auth: false,
  userInfo: null,
  login: undefined,
  authError: false,
  authLoader: false,
  notificationList: [],
  language: LANGUAGE.EN,
  dashboardLoader: false,
};

export const systemReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(authLoaderAC, (state, action) => {
      state.authLoader = action.payload;
    })
    .addCase(dashboardLoaderAC, (state, action) => {
      state.dashboardLoader = action.payload;
    })
    .addCase(authErrorAC, (state, action) => {
      state.authError = action.payload;
    })
    .addCase(authAC, (state, action) => {
      state.auth = true;
      state.login = action.payload.login;
    })
    .addCase(setCurrentUserInfoAC, (state, action) => {
      state.userInfo = action.payload.user;
    })
    .addCase(logoutAC, (state) => {
      state.auth = false;
      state.login = undefined;
      state.userInfo = null;

      deleteCookie("tindaRemoteMerchant");
    })
    .addCase(languageAC, (state, action) => {
      localStorage.setItem("language", action.payload);
      state.language = action.payload;
    })
    .addCase(addNotificationAC, (state, action) => {
      state.notificationList.push(action.payload);
    })
    .addCase(deleteNotificationAC, (state, action) => {
      state.notificationList = state.notificationList.filter(
        (item) => item.id !== action.payload,
      );
    });
});
